/* ============================================================
   REXWOOD FURNITURE — THEME JS
   Uses Shopify's real Ajax Cart API (/cart/add.js, /cart/change.js,
   /cart.js) so the drawer always reflects the real cart.
   ============================================================ */
(function () {
  "use strict";

  /* iPhone/iPod-only hook. Android, iPad and desktop remain untouched. */
  var isHoiIPhone = /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isHoiIPhone) document.documentElement.classList.add("hoi-ios-iphone");

  var routes = (window.RexwoodTheme && window.RexwoodTheme.routes) || {};

  /* ---------------------------------------------------------
     Helpers
     --------------------------------------------------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return "£" + amount;
  }

  function showToast(msg) {
    var toast = qs("#toast");
    var toastMsg = qs("#toastMsg");
    if (!toast || !toastMsg) return;
    toastMsg.textContent = msg;
    toast.classList.add("show");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.classList.remove("show"); }, 2200);
  }

  /* ---------------------------------------------------------
     Overlay / drawer plumbing
     --------------------------------------------------------- */
  var overlay = qs("[data-overlay]");
  var cartDrawer = qs("#cartDrawer");
  var wishlistDrawer = qs("#wishlistDrawer");
  var searchOverlay = qs("[data-search-overlay]");
  var mobileNav = qs("[data-mobile-nav]");

  function setPanelState(panel, isOpen) {
    if (!panel) return;
    panel.classList.toggle("open", isOpen);
    panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    if (isOpen) {
      panel.removeAttribute("inert");
    } else {
      panel.setAttribute("inert", "");
    }
  }

  function closeAllPanels() {
    setPanelState(cartDrawer, false);
    setPanelState(wishlistDrawer, false);
    setPanelState(searchOverlay, false);
    setPanelState(mobileNav, false);
    if (overlay) overlay.classList.remove("open");
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    if (typeof window.hoiResetCheckoutButtons === "function") {
      window.hoiResetCheckoutButtons();
    }
    setPanelState(cartDrawer, true);
    if (overlay) overlay.classList.add("open");
  }

  function openWishlistDrawer() {
    if (!wishlistDrawer) return;
    renderWishlistDrawer();
    setPanelState(wishlistDrawer, true);
    if (overlay) overlay.classList.add("open");
  }

  function openSearchOverlay() {
    if (!searchOverlay) return;
    setPanelState(searchOverlay, true);
    var input = qs("#searchInput");
    if (input) setTimeout(function () { input.focus(); }, 150);
  }

  function openMobileNav() {
    if (!mobileNav) return;
    setPanelState(mobileNav, true);
    if (overlay) overlay.classList.add("open");
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-open-cart]")) { e.preventDefault(); openCartDrawer(); }
    if (e.target.closest("[data-close-cart]")) { e.preventDefault(); closeAllPanels(); }
    if (e.target.closest("[data-open-wishlist]")) { e.preventDefault(); openWishlistDrawer(); }
    if (e.target.closest("[data-close-wishlist]")) { e.preventDefault(); closeAllPanels(); }
    if (e.target.closest("[data-open-search]")) { e.preventDefault(); openSearchOverlay(); }
    if (e.target.closest("[data-search-close]")) { e.preventDefault(); closeAllPanels(); }
    if (e.target.closest("[data-open-mobile-nav]")) { e.preventDefault(); openMobileNav(); }
    if (e.target.closest("[data-close-mobile-nav]")) { e.preventDefault(); closeAllPanels(); }
    if (e.target === overlay) { closeAllPanels(); }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAllPanels();
  });

  qsa(".mobile-nav a").forEach(function (a) {
    a.addEventListener("click", closeAllPanels);
  });

  /* ---------------------------------------------------------
     CART — Ajax API
     --------------------------------------------------------- */
  function updateCartBadge(count) {
    qsa("[data-cart-badge]").forEach(function (el) { el.textContent = count; });
  }

  function renderCartLine(item) {
    var imgHtml = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, "$1") + '" alt="' + (item.product_title || "") + '" loading="lazy" decoding="async" width="72" height="72">'
      : "";
    var visibleProperties = item.properties ? Object.keys(item.properties).filter(function (key) {
      return key.charAt(0) !== "_" && item.properties[key];
    }).map(function (key) {
      return '<div class="variant">' + key + ': ' + item.properties[key] + '</div>';
    }).join("") : "";
    var isFloorChargeItem = item.properties && item.properties['_Floor Charge Item'] === 'true';
    return (
      '<div class="cart-line" data-cart-line data-key="' + item.key + '">' +
        '<div class="thumb">' + imgHtml + '</div>' +
        '<div class="cart-line-body">' +
          '<div class="title">' + item.product_title + '</div>' +
          (item.variant_title && item.variant_title !== "Default Title" ? '<div class="variant">' + item.variant_title + '</div>' : '') +
          visibleProperties +
          '<div class="qty-row">' +
            (isFloorChargeItem
              ? '<div class="qty-stepper"><span data-qty-value>1</span></div>'
              : '<div class="qty-stepper">' +
                  '<button type="button" data-cart-action="dec" data-key="' + item.key + '" aria-label="Decrease quantity">−</button>' +
                  '<span data-qty-value>' + item.quantity + '</span>' +
                  '<button type="button" data-cart-action="inc" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
                '</div>') +
            '<span class="line-price" data-line-price>' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          (isFloorChargeItem ? '' : '<button type="button" class="remove-line" data-cart-action="remove" data-key="' + item.key + '">Remove</button>') +
        '</div>' +
      '</div>'
    );
  }

  function renderCartDrawer(cart) {
    var body = qs("#cartBody");
    var foot = qs("#cartFoot");
    if (!body || !foot) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="empty-state">' +
          '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1"><circle cx="9" cy="21" r="1.4"/><circle cx="19" cy="21" r="1.4"/><path d="M2.5 3h2.4l2.6 12.4A2 2 0 0 0 9.4 17H18a2 2 0 0 0 2-1.6L21.7 7H6.2"/></svg>' +
          '<p>Your cart is empty.</p>' +
        '</div>';
      foot.innerHTML = '<a href="' + (routes.cartUrl || "/cart") + '" class="btn btn-dark btn-full" data-close-cart>Return To Shop</a>';
    } else {
      body.innerHTML = cart.items.map(renderCartLine).join("");
      foot.innerHTML =
        '<div class="subtotal-row"><span>Subtotal</span><span data-cart-subtotal>' + formatMoney(cart.total_price) + '</span></div>' +
        '<small>Taxes, shipping and discount codes calculated at checkout.</small>' +
              '<a href="/checkout" class="btn btn-primary btn-full" data-checkout onclick="if(window.hoiTriggerCheckout){return window.hoiTriggerCheckout(this,event);}event.preventDefault();window.location.assign(&quot;/checkout&quot;);return false;">Check Out</a>';
    }
    updateCartBadge(cart.item_count);
  }

  document.addEventListener("hoi:cart-updated", function (event) {
    var detail = event.detail || {};
    if (detail.cart) renderCartDrawer(detail.cart);
    if (detail.message) showToast(detail.message);
    if (detail.open) openCartDrawer();
  });

  function fetchCart() {
    return fetch((routes.cartJsonUrl || "/cart.js"), { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(variantId, quantity) {
    if (!variantId) {
      showToast("This product has no purchasable variant selected.");
      return Promise.resolve();
    }
    return fetch(routes.cartAddUrl || "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        showToast("Added to cart");
        openCartDrawer();
      })
      .catch(function (err) {
        showToast((err && err.description) || "Couldn't add this item right now.");
      });
  }

  function changeCartLine(key, quantity) {
    if (quantity !== 0) {
      return fetch(routes.cartChangeUrl || "/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCartDrawer(cart); });
    }

    // Removing a furniture line also removes its linked Floor Charge line, if present.
    return fetchCart().then(function (cart) {
      var target = cart.items.find(function (item) { return item.key === key; });
      var group = target && target.properties && target.properties['_Floor Charge Group'];
      if (!group) {
        return fetch(routes.cartChangeUrl || "/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function (r) { return r.json(); });
      }

      var updates = {};
      updates[key] = 0;
      cart.items.forEach(function (item) {
        if (item.key !== key && item.properties && item.properties['_Floor Charge Group'] === group) updates[item.key] = 0;
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json(); });
    }).then(function (cart) { renderCartDrawer(cart); });
  }

  // Initial badge count from server-rendered value already present in DOM.

  document.addEventListener("click", function (e) {
    var addBtn = e.target.closest("[data-add-to-cart]");
    if (addBtn) {
      e.preventDefault();
      addToCart(addBtn.dataset.variantId, 1);
      return;
    }

    var stepBtn = e.target.closest("[data-cart-action]");
    if (stepBtn) {
      e.preventDefault();
      var key = stepBtn.dataset.key;
      var line = stepBtn.closest("[data-cart-line]");
      var qtyEl = line ? line.querySelector("[data-qty-value]") : null;
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var action = stepBtn.dataset.cartAction;
      var newQty = currentQty;
      if (action === "inc") newQty = currentQty + 1;
      if (action === "dec") newQty = Math.max(0, currentQty - 1);
      if (action === "remove") newQty = 0;
      changeCartLine(key, newQty);
    }
  });

  // Legacy product form support. Premium product forms are handled by product-page.js.
  qsa("[data-product-form]").forEach(function (productForm) {
    var legacyVariantInput = qs("#variantIdInput", productForm);
    if (!legacyVariantInput) return;

    productForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var quantityInput = qs("#quantityInput", productForm);
      var variantId = legacyVariantInput.value;
      var qty = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;
      var btn = qs("#addToCartBtn", productForm);
      var originalText = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
      addToCart(variantId, qty).finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = originalText || "Add to Cart"; }
      });
    });
  });

  /* ---------------------------------------------------------
     PRODUCT PAGE — quantity stepper + variant selection
     --------------------------------------------------------- */
  var qtyValue = qs("#qtyValue");
  if (qtyValue) {
    qsa("[data-qty-action]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var current = parseInt(qtyValue.textContent, 10) || 1;
        var next = btn.dataset.qtyAction === "inc" ? current + 1 : Math.max(1, current - 1);
        qtyValue.textContent = next;
        var hidden = qs("#quantityInput");
        if (hidden) hidden.value = next;
      });
    });
  }

  var productJsonEl = qs("[data-product-json]");
  if (productJsonEl && !productJsonEl.closest("[data-product-section]")) {
    var product;
    try { product = JSON.parse(productJsonEl.dataset.productJson || productJsonEl.textContent); } catch (err) { product = null; }

    function findMatchingVariant() {
      if (!product) return null;
      var selects = qsa("[data-option-selector]");
      var selectedValues = selects.map(function (s) { return s.value; });
      return product.variants.find(function (v) {
        return v.options.every(function (optVal, i) { return optVal === selectedValues[i]; });
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      var priceEl = qs("#productPrice");
      var input = qs("#variantIdInput");
      var stockEl = qs("#stockStatus");
      var addBtn = qs("#addToCartBtn");

      if (input) input.value = variant.id;

      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="was">' + formatMoney(variant.compare_at_price) + '</span>' +
            '<span class="now">' + formatMoney(variant.price) + '</span>';
        } else {
          priceEl.textContent = formatMoney(variant.price);
        }
      }

      if (stockEl) {
        stockEl.textContent = variant.available ? "In stock, ready to ship" : "Currently out of stock";
        stockEl.className = "stock-status " + (variant.available ? "in" : "out");
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? "Add to Cart" : "Sold Out";
      }

      // Swap main gallery image if this variant has one
      if (variant.featured_image) {
        var mainImg = qs("#galleryMainImg");
        if (mainImg) mainImg.src = variant.featured_image.src || variant.featured_image;
      }
    }

    qsa("[data-option-selector]").forEach(function (select) {
      select.addEventListener("change", function () {
        var variant = findMatchingVariant();
        if (variant) updateForVariant(variant);
      });
    });
  }

  // Gallery thumbnails
  qsa("[data-gallery-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var mainImg = qs("#galleryMainImg");
      if (mainImg) mainImg.src = thumb.dataset.full;
      qsa("[data-gallery-thumb]").forEach(function (t) { t.classList.remove("active"); });
      thumb.classList.add("active");
    });
  });

  /* ---------------------------------------------------------
     WISHLIST — localStorage plus a functional wishlist drawer
     --------------------------------------------------------- */
  var WISHLIST_KEY = "homeofinterior_wishlist";
  var LEGACY_WISHLIST_KEY = "rexwood_wishlist";

  function normalizeWishlist(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.map(function (item) {
      if (typeof item === "string" || typeof item === "number") {
        return { id: String(item), handle: String(item), title: "", url: "", image: "", price: 0 };
      }
      return item && typeof item === "object" ? item : null;
    }).filter(Boolean);
  }

  function getWishlist() {
    try {
      var primary = JSON.parse(localStorage.getItem(WISHLIST_KEY));
      if (Array.isArray(primary)) return normalizeWishlist(primary);
      return normalizeWishlist(JSON.parse(localStorage.getItem(LEGACY_WISHLIST_KEY)) || []);
    } catch (e) { return []; }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
      localStorage.setItem(LEGACY_WISHLIST_KEY, JSON.stringify(list));
    } catch (e) { /* storage unavailable */ }
  }

  function wishlistIdentity(item) {
    return String(item.handle || item.id || "");
  }

  function updateWishBadge() {
    var count = getWishlist().length;
    qsa("[data-wish-badge]").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderWishlistDrawer() {
    var body = qs("#wishlistBody");
    var foot = qs("#wishlistFoot");
    if (!body || !foot) return;
    var list = getWishlist();

    if (!list.length) {
      body.innerHTML = '<div class="empty-state"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 20.5S4 16 4 9.5A4.5 4.5 0 0 1 12 6.7a4.5 4.5 0 0 1 8 2.8c0 6.5-8 11-8 11Z"/></svg><p>Your wishlist is empty.</p></div>';
      foot.innerHTML = '<a href="/collections/all" class="btn btn-dark btn-full">Continue Shopping</a>';
      updateWishBadge();
      return;
    }

    body.innerHTML = list.map(function (item) {
      var identity = wishlistIdentity(item);
      var title = item.title || "Saved product";
      var url = item.url || (item.handle && !/^\d+$/.test(item.handle) ? "/products/" + item.handle : "/collections/all");
      var image = item.image ? '<img src="' + item.image + '" alt="' + title.replace(/"/g, "&quot;") + '" loading="lazy" decoding="async" width="72" height="72">' : '';
      var price = item.price ? '<div class="variant">' + formatMoney(Number(item.price)) + '</div>' : '';
      return '<div class="cart-line wishlist-line" data-wishlist-line="' + identity + '">' +
        '<a class="thumb" href="' + url + '">' + image + '</a>' +
        '<div class="cart-line-body"><a class="title" href="' + url + '">' + title + '</a>' + price +
        '<button type="button" class="remove-line" data-remove-wishlist="' + identity + '">Remove</button></div></div>';
    }).join("");
    foot.innerHTML = '<a href="/collections/all" class="btn btn-dark btn-full">Continue Shopping</a>';
    updateWishBadge();
  }

  function refreshWishButtons() {
    var ids = getWishlist().map(wishlistIdentity);
    qsa("[data-wish-toggle]").forEach(function (btn) {
      var active = ids.indexOf(String(btn.dataset.id)) !== -1;
      btn.classList.toggle("active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wish-toggle]");
    if (btn) {
      e.preventDefault();
      var id = String(btn.dataset.id || "");
      var card = btn.closest(".product-card, [data-product-card]");
      var link = card ? card.querySelector('a[href*="/products/"]') : null;
      var image = card ? card.querySelector("img") : null;
      var titleEl = card ? card.querySelector(".title, .product-title, h3, h2") : null;
      var list = getWishlist();
      var index = list.findIndex(function (item) { return wishlistIdentity(item) === id; });
      if (index === -1) {
        list.push({ id: id, handle: id, title: titleEl ? titleEl.textContent.trim() : "Saved product", url: link ? link.href : "", image: image ? (image.currentSrc || image.src) : "", price: 0 });
        showToast("Added to wishlist");
      } else {
        list.splice(index, 1);
        showToast("Removed from wishlist");
      }
      saveWishlist(list);
      updateWishBadge();
      refreshWishButtons();
      if (wishlistDrawer && wishlistDrawer.classList.contains("open")) renderWishlistDrawer();
      return;
    }

    var remove = e.target.closest("[data-remove-wishlist]");
    if (remove) {
      e.preventDefault();
      var removeId = String(remove.dataset.removeWishlist);
      var filtered = getWishlist().filter(function (item) { return wishlistIdentity(item) !== removeId; });
      saveWishlist(filtered);
      updateWishBadge();
      refreshWishButtons();
      renderWishlistDrawer();
      showToast("Removed from wishlist");
    }
  });

  document.addEventListener("hoi:wishlist-updated", function () {
    updateWishBadge();
    refreshWishButtons();
    if (wishlistDrawer && wishlistDrawer.classList.contains("open")) renderWishlistDrawer();
  });

  updateWishBadge();
  refreshWishButtons();

  /* ---------------------------------------------------------
     PREDICTIVE SEARCH (uses Shopify's predictive search endpoint)
     --------------------------------------------------------- */
  var searchInput = qs("#searchInput");
  var searchResults = qs("#searchResults");
  var searchDebounce;

  if (searchInput && routes.predictiveSearchUrl) {
    searchInput.addEventListener("input", function () {
      clearTimeout(searchDebounce);
      var term = searchInput.value.trim();
      if (term.length < 2) { if (searchResults) searchResults.innerHTML = ""; return; }
      searchDebounce = setTimeout(function () {
        fetch(routes.predictiveSearchUrl + "?q=" + encodeURIComponent(term) + "&resources[type]=product&resources[limit]=5")
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!searchResults) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p style="color:rgba(246,241,231,.6);">No matches yet — press Enter to see full results.</p>';
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              return (
                '<a class="search-result-item" href="' + p.url + '">' +
                  (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="' + p.title + '" loading="lazy" decoding="async" width="56" height="56">' : '') +
                  '<div><div class="title">' + p.title + '</div><div class="price">' + p.price + '</div></div>' +
                '</a>'
              );
            }).join("");
          })
          .catch(function () { /* predictive search unavailable — Enter still submits the real search form */ });
      }, 250);
    });
  }

  /* ---------------------------------------------------------
     FEATURED COLLECTION TABS (Timeless Pieces / Just In)
     --------------------------------------------------------- */
  qsa("[data-tab-bar]").forEach(function (bar) {
    var section = bar.closest("section");
    qsa(".tab-btn", bar).forEach(function (btn) {
      btn.addEventListener("click", function () {
        qsa(".tab-btn", bar).forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
        qsa("[data-tab-panel]", section).forEach(function (panel) {
          panel.classList.toggle("active", panel.id === btn.dataset.tabTarget);
        });
      });
    });
  });

  /* ---------------------------------------------------------
     HEADER SCROLL STATE + BACK TO TOP
     --------------------------------------------------------- */
  var header = qs("[data-header]");
  var toTop = qs("#toTop");
  var scrollTicking = false;
  window.addEventListener("scroll", function () {
    if (!scrollTicking) {
      scrollTicking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (header) header.classList.toggle("scrolled", y > 12);
        if (toTop) toTop.classList.toggle("show", y > 500);
        scrollTicking = false;
      });
    }
  }, { passive: true });

  if (toTop) {
    toTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

})();
